import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SunFilledSvg from "@ant-design/icons-svg/es/asn/SunFilled";
import AntdIcon from "../components/AntdIcon";
var SunFilled = function SunFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SunFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SunFilled.displayName = 'SunFilled';
}
export default /*#__PURE__*/React.forwardRef(SunFilled);